import FetchApi from "../../../customhooks/Functionapi";
import Swal from 'sweetalert2';
import { sendEmailCompleted, sendEmailStep } from "../veiwdocuments/PFD/pdfdocument";
const FetchApis =new FetchApi();

// แสดง loading ระหว่างบันทึก + ส่งเมล (approved ครบ ต้องรอสร้าง pdf แนบเมลด้วย)
// ต้องรอส่งเมลให้เสร็จก่อน เพราะหน้าที่เรียกใช้จะเปลี่ยนหน้าหลังบันทึกสำเร็จ (ถ้าไม่รอ request ส่งเมลจะถูกยกเลิก)
export function showSendingLoading() {
    Swal.fire({
        title: "กำลังรอส่งข้อมูลอนุมัติ",
        text: "กรุณารอสักครู่ ห้ามปิดหน้านี้",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
            Swal.getContainer().style.zIndex = 2000; // แสดงเหนือ Dialog ของ MUI
            Swal.showLoading();
        }
    });
}

// บันทึกไม่สำเร็จ ปิด loading (บันทึกสำเร็จ หน้าที่เรียกใช้จะแสดง popup แจ้งผลทับ loading เอง)
function closeSendingLoading(res_data) {
    if (!res_data || Number(res_data.status) !== 200) {
        Swal.close();
    }
}

// ส่งเมลไม่สำเร็จไม่ถือว่าการอนุมัติล้มเหลว (บันทึกลงฐานข้อมูลแล้ว)
async function waitSendEmail(sendEmail) {
    try {
        await sendEmail();
    } catch (err) {
        console.log(err);
    }
}

const d = new Date();
let convertdate = ""
let convertmonth = d.getMonth() + 1;
if (d.getDate() < 10) {
    convertdate = "0" + d.getDate();
}
else {
    convertdate = d.getDate();
}
if (d.getMonth() + 1 < 10) {
    convertmonth = "0" + convertmonth
} else {
    convertmonth = convertmonth
}
var timestampsnow = d.getFullYear() + "-" + convertmonth + "-" + convertdate + " " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
var timestampsDate = d.getFullYear() + "-" + convertmonth + "-" + convertdate;


export async function ApprovedById(data,userId,flowStatus,flowStateEnd,stamptimeUpdate) {
var res_data=null

 var ob={
    journalId:data[0].JournalID,
    stateflow:data[0].stateflow,
    statusType:flowStatus,
    UserId:userId,
    StateEnd:flowStateEnd,
    stamptimeUpdate:stamptimeUpdate
 }

   showSendingLoading();
   await FetchApis.FethcPost(`/flowrunsystem/updateFlowrunByState`,ob).then(res=>{
    res_data=res
    })
   if (res_data && res_data.completed) {
      await waitSendEmail(() => sendEmailCompleted(ob.journalId)); // approved คนสุดท้าย ส่งเมลพร้อม pdf
   } else if (res_data && res_data.sendmail) {
      await waitSendEmail(() => sendEmailStep(ob.journalId, { userId: userId, stateflow: ob.stateflow, typeEvent: 'approved' })); // ส่งเมลหาขั้นถัดไป (ไม่แนบ pdf)
   }
   closeSendingLoading(res_data);

    return res_data;
}


export async function ApprovedSend(data,userId,flowStatus,flowStateEnd,stamptimeUpdate) {
    var res_data=null
    
     var ob={
        journalId:data[0].JournalID,
        stateflow:data[0].stateflow,
        statusType:flowStatus,
        UserId:userId,
        StateEnd:flowStateEnd,
        stamptimeUpdate:stamptimeUpdate
     }
    // console.log(ob)
       showSendingLoading();
       await FetchApis.FethcPost(`/flowrunsystem/updateFlowrunByState`,ob).then(res=>{
        res_data=res
        })
       if (res_data && res_data.completed) {
          await waitSendEmail(() => sendEmailCompleted(ob.journalId)); // approved คนสุดท้าย ส่งเมลพร้อม pdf
       } else if (res_data && res_data.sendmail) {
          await waitSendEmail(() => sendEmailStep(ob.journalId, { userId: userId, stateflow: ob.stateflow, typeEvent: 'approved' })); // ส่งเมลหาขั้นถัดไป (ไม่แนบ pdf)
       }
       closeSendingLoading(res_data);

        return res_data;
    }

    
// การอัพเดท แบบกลุ่ม (เอกสารเดียว ไม่ส่งเมล : ส่งเมลรวมทั้งกลุ่มใน ApprovedGroupList)
export async function ApprovedGroupSend(data,userId,flowStatus,flowStateEnd) {
    var res_data=null

     var ob={
        journalId:data.JournalID,
        stateflow:data.stateflow,
        statusType:flowStatus,
        UserId:userId,
        StateEnd:flowStateEnd,
        stamptimeUpdate:timestampsnow
     }
    // console.log(ob)
       await FetchApis.FethcPost(`/flowrunsystem/updateFlowrunGroupByState`,ob).then(res=>{
        res_data=res
        })

        return res_data;
    }

// อนุมัติทุกเอกสารในกลุ่ม (ทีละเอกสาร) แล้วส่งเมลรวมทั้งกลุ่ม
// - ขั้นนี้อนุมัติครบ (sendmail) : ส่งเมลกลุ่ม 1 ครั้ง หาผู้อนุมัติขั้นถัดไป
// - approved คนสุดท้าย (completed) : ส่งเมลสรุป 1 ฉบับต่อกลุ่ม หาทุกคนใน flow (ไม่แนบ pdf)
// - ขั้นนี้ยังมีคนที่ยังไม่อนุมัติ : ไม่ส่งเมล
export async function ApprovedGroupList(datajournal, userId) {
    const completedIds = [];
    let nextStepJournal = null;

    for (let index = 0; index < datajournal.length; index++) {
        const data = datajournal[index];
        try {
            const res = await FetchApis.FethcPost(`/flowrunsystem/flowrunByUserId`, {
                journalId: data.JournalID,
                stateflow: data.stateflow,
                UserId: userId
            })
            if (!res || res.data.length === 0) {
                continue;
            }
            const res_data = await ApprovedGroupSend(data, userId, res.data[0].statusType, res.data[0].stateEnd);
            console.log(res_data)
            if (res_data && res_data.completed) {
                completedIds.push(data.JournalID);
            } else if (res_data && res_data.sendmail && !nextStepJournal) {
                nextStepJournal = data;
            }
        } catch (err) {
            console.log(err);
        }
    }

    if (nextStepJournal) {
        // stateflow ก่อนอนุมัติ : backend ส่งหาผู้อนุมัติขั้น stateflow + 1
        await waitSendEmail(() => FetchApis.FethcPost(`/flowrunsystem/sendEmailflowgroup`, {
            journalCode: nextStepJournal.JournalCode,
            stateflow: nextStepJournal.stateflow,
            TypeEvent: 'approved',
            datetimes: '',
        }));
    }
    if (completedIds.length > 0) {
        await waitSendEmail(() => FetchApis.FethcPost(`/flowrunsystem/sendEmailGroupCompleted`, { journalIds: completedIds }));
    }
}


export async function RecievedById(data,userId,flowStatus,flowStateEnd,timestampsnow) {
var res_data=null

    var ob={
        journalId:data[0].JournalID,
        stateflow:data[0].stateflow,
        UserId:userId,
        stamptimeUpdate:timestampsnow
     }

     await FetchApis.FethcPost(`/flowrunsystem/updateFlowrunrecieved`,ob).then(res=>{
        console.log(res)
        res_data=res
    })
    return res_data;
}

export async function rejectById(data) {
    var res_data=null
    showSendingLoading();
    await FetchApis.FethcPost(`/flowrunsystem/updateFlowrunreject`,data).then(res=>{
        res_data=res
    })
    if (res_data && res_data.sendmail) {
        // ส่งเมลตีกลับ (ไม่แนบ pdf)
        await waitSendEmail(() => sendEmailStep(data.journalId, { userId: data.UserId, stateflow: data.stateflow, typeEvent: 'reject', rejectTo: data.rejectToId }));
    }
    closeSendingLoading(res_data);
    return res_data;
}


export async function EditReject(data) {
    var res_data=null
        console.log(data)
    showSendingLoading();
    await FetchApis.FethcPost(`/flowrunsystem/updateFlowruneditreject`,data).then(res=>{
           res_data=res
           console.log(res)
    })
    if (res_data && res_data.sendmail) {
        // ส่งเมลหาขั้นถัดไป (ไม่แนบ pdf)
        await waitSendEmail(() => sendEmailStep(data.documentId, { userId: data.userId, stateflow: data.stateflow, typeEvent: 'approved' }));
    }
    closeSendingLoading(res_data);

    return res_data;
}


